export enum Role {
    Administrator = 'Administrator',
    Monitor = 'Monitor',
}